<template>
    <vue-ueditor-wrap v-model="editorValue" :config="editorConfig" editor-id="blue-editor-007" @ready="UEditorReady" :editor-dependencies="['ueditor.all.js']"></vue-ueditor-wrap>
</template>

<script>
// 参考：https://blog.csdn.net/m0_46412695/article/details/138752897
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name: 'VEditor',
    components: { VueUeditorWrap },
    props: {
        width: { type: String, default: '100%' },
        height: { type: Number, default: 550 },
        editorContent: { type: String, default: '' },
        showTools: { type: Boolean, default: true }
    },
    data () {
        return {
            editorConfig: {
                // 指定UEditor静态资源的根路径
                UEDITOR_HOME_URL: '/static/UE/',
                // 服务端接口，也就是图片上传接口
                serverUrl: '',
                // 初始宽度
                initialFrameWidth: '100%',
                // 初始高度
                initialFrameHeight: null,
                // 编辑器撑高
                autoHeightEnabled: false,
                autoFloatEnabled: true,
                // 是否开启远程图片抓取转存
                catchRemoteImageEnable: true,
                // 是否显示元素路径
                elementPathEnabled: false,
                // 是否开启字数统计
                wordCount: true,
                // 关闭自动保存
                enableAutoSave: false,
                // 允许的最大字符数
                maximumWords: 1000000,
                wordCountMsg: '当前已输入{#count}个字符',
                wordOverFlowMsg: '<span style=\"color:red;\">当前已输入{#count}个字符，字数超出限制！</span>',
                // 工具栏项配置
                toolbars: this.showTools ? [[
                    'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
                    'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
                    'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
                    'directionalityltr', 'directionalityrtl', 'indent', '|'
                ], [
                    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
                    'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
                    // 'simpleupload', 'insertimage', 'insertvideo', 'attachment', 'pagebreak', 'template', 'background', '|',
                    'horizontal', 'date', 'time', 'spechars', 'wordimage', '|',
                    'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
                    'preview', 'searchreplace', '|'
                ]] : [],
                messageHandleCount: 1
            },
            editorToolConf: [[
                'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
                'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
                'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
                'directionalityltr', 'directionalityrtl', 'indent', '|'
            ], [
                'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
                'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
                // 'simpleupload', 'insertimage', 'insertvideo', 'attachment', 'pagebreak', 'template', 'background', '|',
                'horizontal', 'date', 'time', 'spechars', 'wordimage', '|',
                'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
                'preview', 'searchreplace', '|'
            ]],
            UEditor: null
        }
    },
    watch: {
        height (val) {
            // console.log('高度：', val)
            // this.editorConfig.initialFrameHeight = val - 120 - 23
            this.setEditorHeight(val)
        }
    },
    methods: {
        setEditorHeight (val) {
            if (document.getElementsByClassName('edui-editor').length > 0) {
                var eduiId = document.getElementsByClassName('edui-editor')[0].id

                // console.log('审核框：', window.document.getElementById('edui1').style)
                window.document.getElementById(eduiId).style.height = ('height', val + 'px')
                // $('#edui1_iframeholder').css('height','calc(100% - 10px)');
                // edui1_toolbarbox高度
                var toolbarHeight = window.document.getElementById(eduiId + '_toolbarbox').clientHeight
                var bottombarHeight = window.document.getElementById(eduiId + '_bottombar').clientHeight
                // console.log('工具栏高度:', toolbarHeight, '底部状态栏高度:', bottombarHeight)
                window.document.getElementById(eduiId + '_iframeholder').style.height = (val - toolbarHeight - bottombarHeight) + 'px'
            }
            else {
                setTimeout(() => {
                    this.setEditorHeight(val)
                }, 700);
            }
        },
        UEditorReady (instance) {
            console.log(this.$parent)
            this.height = this.$parent.getContentWinHeight()
            console.log('内容区域高度：', this.height)
            this.setEditorHeight(this.height)
            this.UEditor = instance;
            console.log('是否可编辑：', this.showTools ? '是' : '否')
            console.log(this.UEditor)
            if (this.showTools === false) {
                this.UEditor.setDisabled()
            }
        },
        getWordCount () {
            // return this.UEditor.getContentLength(true)
            console.log('准备获取编辑器字数')
            if (document.getElementsByClassName('edui-editor').length > 0) {
                var eduiId = document.getElementsByClassName('edui-editor')[0].id
                var wordMsg = window.document.getElementById(eduiId + '_wordcount').innerText
                // console.log(wordMsg)
                var mchResult = wordMsg.match(/当前已输入(\d+)个字符/)
                if (mchResult == null) return 0
                else return parseInt(mchResult[1])
            }
            else {
                return this.UEditor.getPlainTxt().length
            }
        },
        getIFrame () {
            return window.document.querySelector('[id^="ueditor_"]').contentWindow
        },
        getHtml () {
            // console.log('获取编辑器Html：', this.UEditor.getContent())   // 也是纯文本，只不过空格是&nbsp;
            // console.log('获取编辑器Html2：', this.UEditor.getAllHtml())  // 完整的Html
            // console.log('获取纯文本：', this.UEditor.getPlainTxt())      // 纯文本，就跟看到的一样
            if (this.UEditor && this.UEditor.getAllHtml) {
                return this.UEditor.getAllHtml().replace('&nbsp;', ' ')
            } else {
                console.log('编辑器还没有准备好')
                return null
            }
        },
        setHtml (val) {
            console.log('设置编辑器内容')
            this.UEditor.body.innerHTML = val
            // 手动触发字数统计
            this.UEditor.execCommand('wordcount')
            this.UEditor.fireEvent('contentChange')
            console.log('设置完成')
        }
    },
    computed: {
        getEditorWidth () { return this.width },
        editorValue: {
            get () { return this.editorContent },
            set (value) { this.$emit('saveEditor', value) }
        },
        // 计算属性
        dynamicStyle () {
            return {
                width: this.windowWidth + 'px',
                height: this.windowHeight + 'px'
            }
        },
        windowWidth () { return window.innerWidth * 0.85 },
        windowHeight () { return window.innerHeight * 0.75 }
    },
    mounted () {
    }
}
</script>

<style scoped>
#blue-editor-007 {
    height: 100%;
}
#edui1 {
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/VEditor.vue